import {
	Table, Popconfirm, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import {
	reAdministrativeTerritoryActions
}from './store/actions'
import moment from "moment"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import ReAdministrativeTerritoryChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'
import CustomFilters from '../../../components/CustomFilters'

const ReAdministrativeTerritory = (props) => {
	const { isModify = false } = props
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [auditVisible, setAuditVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const [audit, setAudit] = useState(null)
	const [count, setCount] = useState(0)
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [filter, setFilter] = useState({})
	const [searchFilter] = useDebounce(filter, 500)
	const { isSending, changed, paged, pagedAudit } = useSelector((state) => state.reAdministrativeTerritoryReducer)
	const dispatch = useDispatch()

	const getPaged = params => {
		dispatch(reAdministrativeTerritoryActions.getPaged(params))
	}
	const getPagedAll = params => {
		dispatch(reAdministrativeTerritoryActions.getPagedAll(params))
	}
	const getPagedAudit = (params) => {
		dispatch(reAdministrativeTerritoryActions.getPagedAudit(params))
	}
	const create = params => {
		dispatch(reAdministrativeTerritoryActions.create(params))
	}
	const remove = params => {
		dispatch(reAdministrativeTerritoryActions.remove(params))
	}
	const update = params => {
		dispatch(reAdministrativeTerritoryActions.update(params))
	}
	const restore = params => {
		dispatch(reAdministrativeTerritoryActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reAdministrativeTerritoryActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchFilter])

	useEffect(() => {
		onPaginationAuditChange(1)
	}, [audit])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name       : searchFilter?.name?.trim(),
			reDistrict : searchFilter?.reDistrict?.trim(),
			reRegion   : searchFilter?.reRegion?.trim(),
			pageSize   : pageSize,
			page       : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	function onPaginationAuditChange(value){
		if (audit){
			getPagedAudit({
				id   : audit,
				page : value,
				pageSize
			})
		}
	}

	const columns = [
		{
			title     : "Код СОАТО",
			dataIndex : 'soato',
			key       : 'soato'
		},
		{
			title     : "Наименование",
			dataIndex : 'name',
			key       : 'name'
		},
		{
			title     : "Тип",
			dataIndex : 'localTypeName',
			key       : 'nalocalTypeName'
		},
		{
			title     : "Район",
			dataIndex : 'districtName',
			key       : 'districtName'
		},
		{
			title     : "Регион",
			dataIndex : 'regionName',
			key       : 'regionName'
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	const columnsAudit = [
		{
			dataIndex : "action",
			key       : "action",
			title     : "Действие"
		},
		{
			title     : "Код СОАТО",
			dataIndex : 'soato',
			key       : 'soato'
		},
		{
			title     : "Наименование",
			dataIndex : 'name',
			key       : 'name'
		},
		{
			title     : "Тип",
			dataIndex : 'reLocalTypeName',
			key       : 'nalocalTypeName'
		},
		{
			title     : "Район",
			dataIndex : 'reDistrictName',
			key       : 'districtName'
		},
		{
			title     : "Область",
			dataIndex : 'reRegionName',
			key       : 'regionName'
		},
		{
			key       : "actionDateTime",
			title     : "Дата изменения",
			dataIndex : "actionDateTime"
		},
		{
			title     : "IP-адрес",
			key       : "ip",
			dataIndex : "ip"
		}
	]

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon :RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setAudit(record.id)
							setAuditVisible(true)
						} }
					/>
				</div>
			)
		})
		: null

	return (
		<>
			<CustomFilters
				elements={ [
					{
						name        : "name",
						type        : "input",
						placeholder : "Введите название/код СОАТО",
						onChange    : (value) => setFilter({ ...filter,
							name: value })
					},
					{
						name        : "reDistrict",
						type        : "input",
						placeholder : "Введите название района",
						onChange    : (value) => setFilter({ ...filter,
							reDistrict: value })
					},
					{
						name        : "reRegion",
						type        : "input",
						placeholder : "Введите название области/региона",
						onChange    : (value) => setFilter({ ...filter,
							reRegion: value })
					}
				] }
				visibleButtons={ false }
			/>
			<Table
				columns={ columns }
				dataSource={ table }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1100 } }
			/>
			{
				count > pageSize &&
          <Pagination
          	showQuickJumper
          	current={ page }
          	pageSize={ pageSize }
          	showSizeChanger={ false }
          	size="small"
          	total={ count }
          	onChange={ onPaginationChange }
          />
			}
			{ isModify &&
			<>
				<ReAdministrativeTerritoryChangeForm
					create={ create }
					record={ record }
					setRecord={ setRecord }
					setVisible={ setVisible }
					update={ update }
					visible={ visible }
				/>
				<ModalAudit
					columns={ columnsAudit }
					count={ pagedAudit.count }
					data={ pagedAudit.items }
					setIdRecordAudit={ setAudit }
					setPage={ onPaginationAuditChange }
					setVisible={ setAuditVisible }
					visible={ auditVisible }
				/>
			</> }
		</>
	)
}

export default ReAdministrativeTerritory